<script setup>
import { onMounted, ref, reactive } from 'vue';
import PageHeader from '@/Components/PageHeader.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import Buttons from "@/Components/Buttons.vue";
import ModalAlert from "@/Components/ModalAlert.vue";
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';

const props = defineProps({
    actioncontrol: {
        type: String,
        default: 'view'
    },
    titleup: String,
    events: Array,
    isAdmin: Boolean,
    isAdminCoord: Boolean,
    isSecre: Boolean,
    canWrite: Boolean,
    canDelete: Boolean,
    orderPtePagos: Number,
    orderPtePagosRet: Number,
    orderFacturado: Number,
    orderNoFacturado: Number,
    confConst: Object,
    confGlobal: Object,
    message: String
});

const pinSecurity = ref('')
const action = ref(props.actioncontrol) // Los props son de lectura así que en el template se haré cambios al action segúnn el click a cada boton
const tab = ref(0)

if (action.value == 'view_estados_cuenta') {
    tab.value = 1
}

//console.log(props.listStudentsPtePagosRet)
const msg1 = ref('')
const navigatorVersion = ref('')
const navigatorName = ref('')
onMounted(() => {
    navigatorVersion.value = navigator.appVersion
    navigatorName.value = navigator.appName
    listarDocumentos('_logos');
});


const showModalAlert = ref(false);
const modalAlertTitle = ref('');
const modalAlertMessage = ref('');
const modalAlertType = ref('success');

const showAlert = (message = '', type = 'success', time = 1) => {
    modalAlertTitle.value = type === 'success' || type === 'info' ? '¡Éxito!' : 'Error';
    modalAlertMessage.value = message;
    modalAlertType.value = type === 'success' || type === 'info' ? 'success' : 'error';
    showModalAlert.value = true;
};

/**
 * Section configuration
 * 
 */
console.log(props.confConst)
const tarifaForm = reactive({
    //matriculaGeneral: props.confConst ? props.confConst.matriculaGeneral : 0,
    matriculaInicial: props.confConst ? props.confConst.matriculaInicial : 0,
    matriculaPrimaria: props.confConst ? props.confConst.matriculaPrimaria : 0,
    matriculaSecundaria: props.confConst ? props.confConst.matriculaSecundaria : 0,
    pensionInicial: props.confConst ? props.confConst.pensionInicial : 0,
    pensionPrimaria: props.confConst ? props.confConst.pensionPrimaria : 0,
    pensionSecundaria: props.confConst ? props.confConst.pensionSecundaria : 0,
});

const tarifaSubmit = () => {
    // - LRR mainStore.setUser(profileForm);
    //setUser(profileForm);
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'tarifa',
        //'matriculaGeneral' : tarifaForm.matriculaGeneral,
        'matriculaInicial': tarifaForm.matriculaInicial,
        'matriculaPrimaria': tarifaForm.matriculaPrimaria,
        'matriculaSecundaria': tarifaForm.matriculaSecundaria,
        'pensionInicial': tarifaForm.pensionInicial,
        'pensionPrimaria': tarifaForm.pensionPrimaria,
        'pensionSecundaria': tarifaForm.pensionSecundaria,
    }
    ))
};

const otherConfForm = reactive({
    automatizarAcceso: props.confConst ? props.confConst.automatizarAcceso : 0,
    diaValidarAccesoPago: props.confConst ? props.confConst.diaValidarAccesoPago : 1,
    fechaBloqueo: props.confConst ? props.confConst.fechaBloqueo : '',
    crearOrdenPagoEstudiante: props.confConst ? props.confConst.crearOrdenPagoEstudiante : 0,
    colaboradorPenalidadDescuentoMinuto: props.confConst ? props.confConst.colaboradorPenalidadDescuentoMinuto : '',
    pensionmoraxdia: props.confConst ? props.confConst.pensionmoraxdia : '',
    cobranzamensaje: props.confConst ? props.confConst.cobranzamensaje : '',
});

const otherConfSubmit = () => {
    //
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'finanOtherConf',
        'automatizarAcceso': otherConfForm.automatizarAcceso,
        'diaValidarAccesoPago': otherConfForm.diaValidarAccesoPago,
        'fechaBloqueo': otherConfForm.fechaBloqueo,
        'crearOrdenPagoEstudiante': otherConfForm.crearOrdenPagoEstudiante,
        'colaboradorPenalidadDescuentoMinuto': otherConfForm.colaboradorPenalidadDescuentoMinuto,
        'pensionmoraxdia': otherConfForm.pensionmoraxdia,
        'cobranzamensaje': otherConfForm.cobranzamensaje,
    }
    ))
};


const reloadProps = (contentArray = []) => {
    Inertia.reload({ only: contentArray })
}

const formatDate = (date, type = '') => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    if (type == 'ISO') {
        result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate()
    }
    return result
}

// Ejecutar
const ejecutarConfirm = ref([])
const crearStory = (type = 1) => {

    let ruta = 'student-store-story'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'anio': props.anioEscolar,
        'type': type

    }
    ))

}

const ejecutar = (type = '') => {

    let ruta = 'student-ejecutar'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'type': type

    }
    ))

}

const showAyuda = ref([
    { 'ordenpago': false },
    { 'configuracion': false },
    { 'cobranzas': false },
    { 'facture': false }
])

/**
 * Procesar archivos adjuntos
 */
const arrayDocumentos = ref([]);
const arrayDocumentosCol = ref([]);
const listarDocumentos = (subruta = '') => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_document_mycompany' + subruta; // Por defecto la primera entidad
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDocumentos.value = respuesta.datalist;
        arrayDocumentosCol.value = respuesta.columnas;
        console.log(arrayDocumentos.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const inputFileName = ref('')
const inputFileDesc = ref('')
const inputFilePos = ref(1)
const showInputFile = ref(false)
const fileDocument = ref(null)
const fileSize = ref(0)
const errorMessage = ref('')
const changeFile = (type) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    let file = null;
    if (type == 'file_document_mycompany_logos' || type == 'file_document_mycompany') {
        file = fileDocument.value.files[0];
    }

    //console.log(file);
    console.log(file.size);

    // FIX error Failed to set the 'value' property on 'HTMLInputElement'
    if (file) {
        fileSize.value = file.size
        if (file.name.includes('.jpg') || file.name.includes('.png')) {
            console.log('Es imagen')
        } else {
            console.log('No es imagen jpg o png')
        }
    }

}

const uploadFile = (type, origin_id = 0) => {
    let data = new FormData()
    let file = null;
    if (type == 'file_document_mycompany_logos' || type == 'file_document_mycompany') {
        file = fileDocument.value.files[0];
        origin_id = 0
    }
    data.append('file', file)
    data.append('origin_type', type)

    // Se puede agregar otro origin id si fuera necesario
    data.append('origin_id', origin_id)

    data.append('name', inputFileName.value)
    data.append('description', inputFileDesc.value)
    data.append('position', inputFilePos.value)
    console.log(file)
    axios.post('/file/upload', data)
        .then(response => {

            if (response.data.error) {
                showAlert(response.data.message, 'danger', 5)
                if (type == 'file_document_mycompany_logos' || type == 'file_document_mycompany') {
                    errorMessage.value == response.data.message
                }
            } else if (response.data.success) {
                showAlert(response.data.message, 'success', 2)
                if (type == 'file_document_mycompany_logos') {
                    listarDocumentos('_logos')
                } else {
                    listarDocumentos()
                }
                cleanInputFile()

            }
            console.log(response.data)
        })
        .catch(error => {
            console.log(error)
        })

}

const cleanInputFile = () => {
    inputFileName.value = ''
    inputFileDesc.value = ''
    inputFilePos.value = 1
    fileDocument.value = null
    fileSize.value = 0
}

const logoInput = ref(null);
const faviconInput = ref(null);
const logoPreview = ref(null);
const faviconPreview = ref(null);

const logoFileToUpload = ref(null);
const faviconFileToUpload = ref(null);
const logoProcessing = ref(false);
const faviconProcessing = ref(false);

const companyForm = useForm({
    ENTIDAD_RUC: props.confGlobal ? props.confGlobal.ENTIDAD_RUC : '',
    COMPANY_NAME: props.confGlobal ? props.confGlobal.COMPANY_NAME : '',
    COMPANY_NAME_SHORT: props.confGlobal ? props.confGlobal.COMPANY_NAME_SHORT : '',
    COMPANY_MAIL: props.confGlobal ? props.confGlobal.COMPANY_MAIL : '',
    COMPANY_PHONE: props.confGlobal ? props.confGlobal.COMPANY_PHONE : '',
    COMPANY_PHONE_MOBILE: props.confGlobal ? props.confGlobal.COMPANY_PHONE_MOBILE : '',
    COMPANY_CONTACT_ADDRESS: props.confGlobal ? props.confGlobal.COMPANY_CONTACT_ADDRESS : '',
    COMPANY_CONTACT_STATE: props.confGlobal ? props.confGlobal.COMPANY_CONTACT_STATE : '',
    COMPANY_CONTACT_CITY: props.confGlobal ? props.confGlobal.COMPANY_CONTACT_CITY : '',
    COMPANY_CONTACT_ZIPCODE: props.confGlobal ? props.confGlobal.COMPANY_CONTACT_ZIPCODE : '',
    SOCIAL_URL_FACEBOOK: props.confGlobal ? props.confGlobal.SOCIAL_URL_FACEBOOK : '',
    SOCIAL_URL_INSTAGRAM: props.confGlobal ? props.confGlobal.SOCIAL_URL_INSTAGRAM : '',
    SOCIAL_URL_TWITTER: props.confGlobal ? props.confGlobal.SOCIAL_URL_TWITTER : '',
    SOCIAL_URL_YOUTUBE: props.confGlobal ? props.confGlobal.SOCIAL_URL_YOUTUBE : '',
    SOCIAL_URL_WHATSAPP: props.confGlobal ? props.confGlobal.SOCIAL_URL_WHATSAPP : '',
    _method: 'put'
});

const isEditing = ref(false);

const triggerLogoUpload = () => logoInput.value.click();
const triggerFaviconUpload = () => faviconInput.value.click();

const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        logoFileToUpload.value = file;
        logoPreview.value = URL.createObjectURL(file);
    }
};

const cancelLogo = () => {
    logoFileToUpload.value = null;
    logoPreview.value = null;
    if (logoInput.value) logoInput.value.value = null;
};

const saveLogo = () => {
    if (!logoFileToUpload.value) return;
    
    logoProcessing.value = true;
    let formData = new FormData();
    formData.append('file', logoFileToUpload.value);
    formData.append('origin_type', 'logo');
    
    axios.post('/constante/actualizarLogos', formData)
        .then(response => {
            if (response.data.success) {
                showAlert(response.data.message, 'success', 3);
                logoFileToUpload.value = null;
                logoPreview.value = null;
                reloadProps(['confGlobal']);
            } else {
                showAlert(response.data.message, 'danger', 3);
            }
        })
        .catch(error => {
            console.error('Error in saveLogo:', error);
            const msg = error.response?.data?.message || error.message || 'Error desconocido';
            showAlert('Error al subir logo: ' + msg, 'danger', 5);
        })
        .finally(() => {
            logoProcessing.value = false;
        });
};

const handleFaviconChange = (event) => {
    const file = event.target.files[0];
    if (file) {
        faviconFileToUpload.value = file;
        faviconPreview.value = URL.createObjectURL(file);
    }
};

const cancelFavicon = () => {
    faviconFileToUpload.value = null;
    faviconPreview.value = null;
    if (faviconInput.value) faviconInput.value.value = null;
};

const saveFavicon = () => {
    if (!faviconFileToUpload.value) return;
    
    faviconProcessing.value = true;
    let formData = new FormData();
    formData.append('file', faviconFileToUpload.value);
    formData.append('origin_type', 'favicon');
    
    axios.post('/constante/actualizarLogos', formData)
        .then(response => {
            if (response.data.success) {
                showAlert(response.data.message, 'success', 3);
                faviconFileToUpload.value = null;
                faviconPreview.value = null;
                reloadProps(['confGlobal']);
            } else {
                showAlert(response.data.message, 'danger', 3);
            }
        })
        .catch(error => {
            console.error('Error in saveFavicon:', error);
            const msg = error.response?.data?.message || error.message || 'Error desconocido';
            showAlert('Error al subir ícono: ' + msg, 'danger', 5);
        })
        .finally(() => {
            faviconProcessing.value = false;
        });
};

const saveChanges = () => {
    const formData = new FormData();
    formData.append('typeConfiguration', 'companyInfo');
    
    const fields = [
        'ENTIDAD_RUC', 'COMPANY_NAME', 'COMPANY_NAME_SHORT', 'COMPANY_MAIL', 'COMPANY_PHONE',
        'COMPANY_PHONE_MOBILE', 'COMPANY_CONTACT_ADDRESS', 'COMPANY_CONTACT_STATE',
        'COMPANY_CONTACT_CITY', 'COMPANY_CONTACT_ZIPCODE', 'SOCIAL_URL_FACEBOOK',
        'SOCIAL_URL_INSTAGRAM', 'SOCIAL_URL_TWITTER', 'SOCIAL_URL_YOUTUBE', 'SOCIAL_URL_WHATSAPP'
    ];
    fields.forEach(field => {
        formData.append(field, companyForm[field] ?? '');
    });

    axios.post('/constante/actualizarEmpresa', formData)
        .then(response => {
            if (response.data.success) {
                isEditing.value = false;
                showAlert(response.data.message || 'Configuración guardada correctamente.', 'success', 3);
                reloadProps(['confGlobal']);
            } else {
                showAlert('Error al guardar la configuración', 'danger', 3);
            }
        })
        .catch(error => {
            console.error('Error in saveChanges:', error);
            const msg = error.response?.data?.message || error.message || 'Error desconocido';
            showAlert('Error al guardar: ' + msg, 'danger', 5);
        });
};

</script>

<template>

    <Head title="Configuración" />

    <ModalAlert 
        :show="showModalAlert" 
        :title="modalAlertTitle" 
        :message="modalAlertMessage"
        :type="modalAlertType"
        :showCancel="false"
        confirmText="Entendido"
        @close="showModalAlert = false" 
        @confirm="showModalAlert = false" 
    />

    <BreezeAuthenticatedLayout>

        <template #header>
            <PageHeader title="Configuración de Empresa" subtitle="Establezca la información de su empresa, logos, favicon y redes sociales." :back-route="null" :show-back="false" >
                <template #actions>
                    <Buttons :href="route('dashboard')" color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Inicio" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template>



        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->
        <div class="py-8 lg:py-10">
            <div class="max-w-6xl mx-auto sm:px-6 lg:px-8 px-4 pb-4">
                <div class="bg-white dark:bg-slate-800 overflow-hidden border border-slate-200 dark:border-slate-700 rounded-xl shadow-sm p-6 lg:p-8">

                    <!-- Headers with Photos -->
                    <div class="grid grid-cols-1 xl:grid-cols-2 gap-8 mb-8 pb-8 border-b border-slate-200 dark:border-slate-700">
                        <!-- Logo Upload -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6">
                            <div class="w-24 h-24 p-2 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden">
                                <img :src="logoPreview || (confGlobal?.COMPANY_LOGO_PATH ? confGlobal.COMPANY_LOGO_PATH : '/documents/mycompany/logos/no_image.png')" class="w-full h-full object-contain" />
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5">Logo Principal</h3>
                                <div class="flex flex-col gap-2 mb-2">
                                    <input type="file" ref="logoInput" class="hidden" @change="handleLogoChange" accept="image/jpeg, image/png, image/svg+xml" />
                                    
                                    <template v-if="logoFileToUpload">
                                        <div>
                                            <span class="inline-block text-sm font-semibold border border-blue-200 bg-blue-50 px-2 py-1 rounded truncate max-w-full" :title="logoFileToUpload.name">{{ logoFileToUpload.name }}</span>
                                        </div>
                                        <div class="flex flex-wrap items-center gap-2">
                                            <Buttons type="button" @click="saveLogo" color="blue" :disabled="logoProcessing" :icon="logoProcessing ? 'tabler:loader-2' : 'mdi:check'" :label="logoProcessing ? 'Guardando...' : 'Guardar'" />
                                            <Buttons type="button" @click="cancelLogo" color="light" icon="mdi:close" label="Cancelar" :disabled="logoProcessing" />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <Buttons type="button" @click="triggerLogoUpload" color="light" icon="mdi:upload" label="Seleccionar logo" class="text-sm" />
                                        </div>
                                    </template>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Permitido JPG, PNG y SVG. Recomendado: formato horizontal. Max 3MB.
                                </p>
                            </div>
                        </div>

                        <!-- Favicon Upload -->
                        <div class="flex flex-col sm:flex-row sm:items-center gap-6 xl:pl-8 xl:border-l border-slate-200 dark:border-slate-700">
                            <div class="w-24 h-24 p-2 rounded-xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center shrink-0 overflow-hidden">
                                <img :src="faviconPreview || (confGlobal?.COMPANY_FAVICON_PATH ? confGlobal.COMPANY_FAVICON_PATH : '/documents/mycompany/logos/no_image.png')" class="w-full h-full object-contain" />
                            </div>
                            <div>
                                <h3 class="text-sm font-bold text-slate-800 dark:text-slate-200 mb-2.5">Ícono (Favicon)</h3>
                                <div class="flex flex-col gap-2 mb-2">
                                    <input type="file" ref="faviconInput" class="hidden" @change="handleFaviconChange" accept="image/jpeg, image/png" />
                                    
                                    <template v-if="faviconFileToUpload">
                                        <div>
                                            <span class="inline-block text-sm font-semibold border border-blue-200 bg-blue-50 px-2 py-1 rounded truncate max-w-full" :title="faviconFileToUpload.name">{{ faviconFileToUpload.name }}</span>
                                        </div>
                                        <div class="flex flex-wrap items-center gap-2">
                                            <Buttons type="button" @click="saveFavicon" color="blue" :disabled="faviconProcessing" :icon="faviconProcessing ? 'tabler:loader-2' : 'mdi:check'" :label="faviconProcessing ? 'Guardando...' : 'Guardar'" />
                                            <Buttons type="button" @click="cancelFavicon" color="light" icon="mdi:close" label="Cancelar" :disabled="faviconProcessing" />
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <Buttons type="button" @click="triggerFaviconUpload" color="light" icon="mdi:upload" label="Seleccionar ícono" class="text-sm" />
                                        </div>
                                    </template>
                                </div>
                                <p class="text-xs text-slate-500 dark:text-slate-400 mt-2">
                                    Permitido JPG y PNG. Recomendado: 512x512px. Max 3MB.
                                </p>
                            </div>
                        </div>
                    </div>

                    <!-- Form Grid -->
                    <form @submit.prevent="">
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-200 mb-4 md:col-span-2">Información de Empresa</h3>
                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Razon Social</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_NAME" type="text" class="w-full" placeholder="Ej. Servicios de Contrucción y Arquitectura del Perú S.A.C.">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_NAME ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_NAME || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Nombre Comercial</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_NAME_SHORT" type="text" class="w-full" placeholder="Ej. SCA Perú S.A.C.">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_NAME_SHORT ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_NAME_SHORT || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Correo Electrónico</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_MAIL" type="email" class="w-full" placeholder="contacto@ejemplo.com">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_MAIL ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_MAIL || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">RUC</label>
                                <input v-if="isEditing" v-model="companyForm.ENTIDAD_RUC" type="text" class="w-full" placeholder="Ej. 20123456789">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.ENTIDAD_RUC ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.ENTIDAD_RUC || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Número de Teléfono</label>
                                <div v-if="isEditing" class="flex gap-2">

                                    <input type="text" v-model="companyForm.COMPANY_PHONE" class="flex-1 w-full" placeholder="Ej. 987 654 321">
                                </div>
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_PHONE ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_PHONE || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Celular</label>
                                <div v-if="isEditing" class="flex gap-2">

                                    <input type="text" v-model="companyForm.COMPANY_PHONE_MOBILE" class="flex-1 w-full" placeholder="Ej. 987 654 321">
                                </div>
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_PHONE_MOBILE ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_PHONE_MOBILE || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Dirección</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_CONTACT_ADDRESS" type="text" class="w-full" placeholder="Ej. Av. Principal 123">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_CONTACT_ADDRESS ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_CONTACT_ADDRESS || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Distrito / Ciudad</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_CONTACT_CITY" type="text" class="w-full" placeholder="Ej. Miraflores">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_CONTACT_CITY ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_CONTACT_CITY || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Departamento / Estado</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_CONTACT_STATE" type="text" class="w-full" placeholder="Ej. Lima">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_CONTACT_STATE ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_CONTACT_STATE || 'Sin registro realizado' }}</div>
                            </div>

                            <div>
                                <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Código Postal</label>
                                <input v-if="isEditing" v-model="companyForm.COMPANY_CONTACT_ZIPCODE" type="text" class="w-full" placeholder="Ej. 15001">
                                <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.COMPANY_CONTACT_ZIPCODE ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.COMPANY_CONTACT_ZIPCODE || 'Sin registro realizado' }}</div>
                            </div>


                            <!-- Redes Sociales -->
                            <div class="col-span-1 md:col-span-2 pt-4 border-t border-slate-200 dark:border-slate-700 mt-2">
                                <h3 class="text-lg font-bold text-slate-800 dark:text-slate-200 mb-4">Redes Sociales</h3>
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Facebook</label>
                                        <input v-if="isEditing" v-model="companyForm.SOCIAL_URL_FACEBOOK" type="url" class="w-full" placeholder="https://facebook.com/miempresa">
                                        <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.SOCIAL_URL_FACEBOOK ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.SOCIAL_URL_FACEBOOK || 'Sin registro realizado' }}</div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Instagram</label>
                                        <input v-if="isEditing" v-model="companyForm.SOCIAL_URL_INSTAGRAM" type="url" class="w-full" placeholder="https://instagram.com/miempresa">
                                        <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.SOCIAL_URL_INSTAGRAM ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.SOCIAL_URL_INSTAGRAM || 'Sin registro realizado' }}</div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Twitter / X</label>
                                        <input v-if="isEditing" v-model="companyForm.SOCIAL_URL_TWITTER" type="url" class="w-full" placeholder="https://twitter.com/miempresa">
                                        <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.SOCIAL_URL_TWITTER ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.SOCIAL_URL_TWITTER || 'Sin registro realizado' }}</div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">Youtube</label>
                                        <input v-if="isEditing" v-model="companyForm.SOCIAL_URL_YOUTUBE" type="url" class="w-full" placeholder="https://youtube.com/miempresa">
                                        <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.SOCIAL_URL_YOUTUBE ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.SOCIAL_URL_YOUTUBE || 'Sin registro realizado' }}</div>
                                    </div>
                                    <div>
                                        <label class="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1.5">WhatsApp (URL)</label>
                                        <input v-if="isEditing" v-model="companyForm.SOCIAL_URL_WHATSAPP" type="url" class="w-full" placeholder="https://wa.me/51987654321">
                                        <div v-else class="w-full px-3 py-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700 rounded-md text-sm cursor-not-allowed" :class="companyForm.SOCIAL_URL_WHATSAPP ? 'text-slate-700 dark:text-slate-300' : 'text-slate-400 italic'">{{ companyForm.SOCIAL_URL_WHATSAPP || 'Sin registro realizado' }}</div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Actions -->
                        <div class="mt-8 pt-6 border-t border-slate-200 dark:border-slate-700 flex flex-wrap items-center gap-3">
                            <Buttons v-if="!isEditing" @click="isEditing = true" type="button" color="blue" label="Modificar" />
                            <template v-else>
                                <Buttons type="button" @click="saveChanges" color="blue" :disabled="companyForm.processing" :icon="companyForm.processing ? 'tabler:loader-2' : null" :label="companyForm.processing ? 'Guardando...' : 'Guardar cambios'" />
                                <Buttons type="button" @click="isEditing = false" color="light" label="Cancelar" />
                            </template>
                        </div>
                    </form>

                </div>
            </div>
        </div>

        <!-- Prueba Documentos -->
        <!-- <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-4 mb-10">
            <div class="grid grid-cols-1 bg-white overflow-hidden border shadow-lg rounded-md p-4">
                <div class="col-span-1">
                    <h2 class="mb-3 text-lg font-bold">PRUEBA UPLOAD LOGO: Documentos adjuntos</h2>
                    <div v-if="canWrite" class="">
                        <p class="my-2 text-sm mb-3">
                            Puede subir archivos PDF, DOCX, PPT, XLSX, JPG,
                            PNG, con un <b>límite máximo</b> de {{
                                confGlobal && confGlobal.DOCUMENT_LIMIT_UPLOAD_FILE ? confGlobal.DOCUMENT_LIMIT_UPLOAD_FILE : 3000 }}
                            KB. <b>Si ingresa un nombre que ya existe el documento anterior será reemplazado por este</b>.
                        </p>
                        <div v-if="fileSize > (1000 * parseInt(confGlobal && confGlobal.DOCUMENT_LIMIT_UPLOAD_FILE ? confGlobal.DOCUMENT_LIMIT_UPLOAD_FILE : 3000))" class="mb-4">
                            <small class="font-medium text-red-600">El archivo supera el tamaño límite permitido</small>
                        </div>
                        <div class="mb-4 w-full">
                            <label for="name" class="text-sm mb-1 font-semibold">Nombre de Archivo </label>
                            <input id="inputname" type="text" class="mt-1 block w-full" v-model="inputFileName" required />
                        </div>
                        <div class="mb-4">
                            <label for="desc" class="text-sm mb-1 font-semibold">Descripción (opcional) </label>
                            <textarea id="inputdesc" type="text" class="mt-1 block w-full h-24" v-model="inputFileDesc" autocomplete="off"> </textarea>
                        </div>
                        <div class="mb-4">
                            <label>
                                <input id="file_document_mycompany_logos" ref="fileDocument" type="file" @change="changeFile('file_document_mycompany_logos')" class="w-full" accept=".PDF, .PNG, .JPG, .DOC, .DOCX, .PPT, .XLSX, .XLS">
                            </label>
                        </div>

                        <Buttons icon="mdi:plus-circle" color="blue" label="Guardar" @click="uploadFile('file_document_mycompany_logos')" />
                    </div>
                    <hr class="my-4">
                 
                    <div class="w-full overflow-x-auto relative">
                        <CardBox v-if="arrayDocumentos.length" class="mb-6" has-table>
                            <TableAdvanced modulo="Documento" modulos="Documentos" :data="arrayDocumentos" :fields="arrayDocumentosCol" ruta="file" :deleteable="canDelete ? true : false" originType="file_document_mycompany_logos" :originId="0" @reload="listarDocumentos('_logos')" />
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
                </div>
            </div>
        </div> -->

    </BreezeAuthenticatedLayout>
</template>
<style lang="css" scoped>
/* :deep(.vue-select .custom-value) {
    display: flex;
    align-items: center;
    gap: 6px;
    }

    :deep(.vue-select .custom-option) {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #171717;
    font-weight: 500;
    font-size: 16px;
    }

    :deep(.vue-select .custom-option small) {
    color: #525252;
    font-weight: 500;
    font-size: 14px;
    } */
</style>
